import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LaunchIcon from "@mui/icons-material/Launch";
import sp_icon from "../../../../../images/sp_icon.png";
import axios, { secondAxios } from "../../../../../api/axios";
import { useParams } from "react-router-dom";

const SharepointTab = ({ plant = false }) => {
  // const { subAssemblyRoute } = props
  const [sharepointLink, setSharepointLink] = useState("");
  const { id, projectId, plantId } = useParams();
  const activeProjectId = projectId || id;
  const resourceId = plant ? plantId : activeProjectId;

  useEffect(() => {
    if (!resourceId) {
      setSharepointLink("");
      return;
    }

    const endpoint = plant ? `/plant/${resourceId}` : `/project/${resourceId}`;

    const getSharePointLink = async () => {
      try {
        const res = await secondAxios.get(endpoint);
        const data = res.data || {};
        const link =
          data.link ||
          data.sharepointLink ||
          data.dcsLink ||
          data?.project?.link ||
          "";
        setSharepointLink(link);
      } catch (error) {
        console.error("Failed to load SharePoint link", error);
        setSharepointLink("");
      }
    };

    getSharePointLink();
  }, [plant, resourceId]);

  const handleClick = () => {
    // Open the link in a new tab
    if (sharepointLink !== "") {
      window.open(sharepointLink, "_blank");
    }
  };

  return (
    <Box
      justifyContent={"center"}
      alignItems={"center"}
      display="flex"
      minHeight="60vh"
    >
      {/* <a href="http://localhost:8000/pv/download">Download Installer</a> */}
      <Card
        sx={{
          width: 370,
          "& .MuiCardMedia-root": { objectFit: "contain" },
          p: 2,
        }}
      >
        <CardMedia
          component="img"
          sx={{ height: 140 }}
          image={sp_icon}
          title="sp icon"
        />
        <CardContent>
          <Typography sx={{ fontSize: 18 }} gutterBottom>
            Access Your Sharepoint Documents here.
          </Typography>
          <br />
        </CardContent>
        <CardActions disableSpacing>
          <Button
            sx={{ backgroundColor: "#1c9ca4", color: "#fff", ml: 2 }}
            variant="contained"
            endIcon={<LaunchIcon />}
            onClick={handleClick}
            disabled={sharepointLink === "" || sharepointLink === null}
          >
            Go to Sharepoint
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default SharepointTab;
